const TOPIC_ITEMS = [
  { id: 1, label: '香蕉视频', hot: true, count: '12.8k 讨论' },
  { id: 2, label: '西瓜视频免费', hot: true, count: '9.6k 讨论' },
  { id: 3, label: '蜜桃视频', hot: true, count: '8.2k 讨论' },
  { id: 4, label: '水果视频在线', hot: false, count: '7.1k 讨论' },
  { id: 5, label: '樱花视频', hot: false, count: '6.5k 讨论' },
  { id: 6, label: '高清在线观看', hot: true, count: '5.8k 讨论' },
  { id: 7, label: '植物视频平台', hot: false, count: '4.9k 讨论' },
  { id: 8, label: '免费全集', hot: false, count: '4.3k 讨论' },
  { id: 9, label: '日剧推荐', hot: false, count: '3.7k 讨论' },
  { id: 10, label: '纪录片精选', hot: false, count: '3.2k 讨论' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2">
            热门话题
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            大家都在关注的水果视频在线平台热门话题与讨论趋势
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {TOPIC_ITEMS.map((item) => (
            <div
              key={item.id}
              className="group flex items-center gap-2.5 px-4 py-2.5 rounded-full bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50 transition-all duration-200 cursor-pointer"
            >
              {item.hot && (
                <span className="w-5 h-5 rounded-full bg-secondary-500 flex items-center justify-center shrink-0">
                  <i className="ri-fire-fill text-background-50 text-[10px]"></i>
                </span>
              )}
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-700 whitespace-nowrap">
                #{item.label}
              </span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{item.count}</span>
            </div>
          ))}
        </div>

        <div className="flex justify-center mt-6">
          <span className="text-xs text-foreground-400">
            <i className="ri-information-line mr-1"></i>
            话题热度基于各水果视频在线平台近7日数据统计
          </span>
        </div>
      </div>
    </section>
  );
}